import dragRelatedFn from './directiveOtherFn/drag';
import dialogDrag from './directiveOtherFn/dialogDrag';

export default {
  dialogDrag,
  /**
   * 拖拽
   * 使用 v-drag="{disabled: true, moveClass:'el-dialog', dragChildClass: 'rd-dialog-title', invalidChildClass: 'rd-dialog-title-content'}"
   * @param disabled: 是否启用拖拽 false是启用
   * @param moveId: 限制拖拽/移动id(当前移动元素)(优先级：id>class>无)(只支持输入一个id)
   * @param moveClass: 限制拖拽/移动class`(当前移动元素)(优先级：id>class>无)(只支持输入一个class)
   * @param dragChildId 限制可拖拽子元素id(输入多个id以空格隔开)
   * @param dragChildClass 限制可拖拽子元素class(输入多个class以空格隔开)
   * @param invalidChildId 限制拖拽块内不可拖拽id元素(输入多个id以空格隔开)
   * @param invalidChildClass 限制拖拽块内不可拖拽class元素(输入多个class以空格隔开)
   * @param isPC 是否为pc端
   * @param beyond 拖动时是否可以超出边界
   */
  drag: {
    bind: (el, binding) => {
      dragRelatedFn(el, binding);
  },
    update: (el, binding) => {
      dragRelatedFn(el, binding);
    },
  },
};



// WEBPACK FOOTER //
// ./src/directive/directive.js